import React from 'react'
import { IconButton } from 'react-toolbox/lib/button'
import CSSModules from 'helpers/CSSModulesUtil'
import notifyHoc from 'containers/App/Notification/Notify'
import T from 'i18n-react'
import { CSVLink } from 'react-csv'

import styles from './styles.scss'

const InfoButton = notifyHoc(IconButton)

const CSVButton = ({ csvData, projectId }) => {
  return (
    <div>
      <CSVLink
        data={csvData}
        filename={'fulcrum_project_' + projectId + '_schedule.csv'}
        target='_blank'
      >
        <InfoButton
          icon='open_in_new'
          message={T.translate('pages.project.view.notification.exportProjectSchedule')}
        />
      </CSVLink>
    </div>
  )
}

export default CSSModules(styles)(CSVButton)
